import { UseDebouncedSuggestionAddressType } from 'application/hooks/useAddressState';

export enum PointCreateModalPages {
  POINT = 'POINT',
  STREAM = 'STREAM',
}

export enum PointCreateWithPaymentModalMode {
  HINT,
  CONFIRM,
}

export interface PointCreateModalProps {
  autoOpened?: boolean;
}

export interface UsePointCreateModalViewModel {
  addressState: UseDebouncedSuggestionAddressType;
  extendCost?: number;
  createPointError?: Error;
  userOnboardingFeaturesLoading: boolean;
  isButtonDisabled: boolean;
  isButtonLoading: boolean;
  isShowHintAboutPrice?: boolean;
  needShowAcceptanceAdvancedModal: boolean;
  isAcceptanceAdvancedNull: boolean;
  isAcceptanceAdvancedPending: boolean;
  canAddPointWithPayment?: boolean;
  onCreatePointButtonClick: () => void;
  openAcceptanceAdvancedSigning: () => void;
}
